import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { ImpactAgentFeedbackStatus } from "gql/apollo/graphql";
import { useCallback, useState } from "react";
import useSnackbar from "utils/useSnackbar";

import { impactAgentFeedbackRefetchQueries } from "./useUpdateImpactAgentFeedback";

export const UpdateImpactAgentFeedbacks = graphql(/* GraphQL */ `
	mutation UpdateImpactAgentFeedbacks(
		$params: UpdateImpactAgentFeedbacksParams!
	) {
		updateImpactAgentFeedbacks(params: $params) {
			success
			error {
				code
				message
			}
		}
	}
`);

export function useBulkUpdateImpactAgentFeedback() {
	const { handleError } = useSnackbar();
	const [loading, setLoading] = useState(false);
	const [updateImpactAgentFeedbacks, { client }] = useMutation(
		UpdateImpactAgentFeedbacks
	);

	const updateFeedbackStatuses = useCallback(
		async (ids: string[], feedbackStatus: ImpactAgentFeedbackStatus) => {
			setLoading(true);

			const failure = await updateImpactAgentFeedbacks({
				variables: {
					params: { feedback_ids: ids, feedback_status: feedbackStatus },
				},
			}).then(
				(result) => {
					const response = result.data?.updateImpactAgentFeedbacks;

					return response?.success && !response.error ?
							null
						:	{ error: response?.error };
				},
				(error: unknown) => ({ error })
			);

			try {
				await client.refetchQueries({
					include: impactAgentFeedbackRefetchQueries,
				});
			} catch (error) {
				handleError(error);
			}

			if (failure) {
				handleError(failure.error, "We couldn't update the selected feedback.");
			}

			setLoading(false);

			return failure ? ids : [];
		},
		[updateImpactAgentFeedbacks, client, handleError]
	);

	return { updateFeedbackStatuses, loading };
}
